import { defineComponent as _defineComponent } from 'vue'
import BCXQuickLayer from '@/components/molecules/BCXQuickLayer.vue';
import { computed, PropType, ref } from 'vue';
import BCXDatePicker from '@/components/molecules/forms/datepicker/BCXDatePicker.vue';
import X from '@/components/svg-components/X.vue';
import { BcxDatePickerTimeLevel } from '@/models/BcxDatePicker';
import useResponsiveness from '@/mixins/useResponsiveness';
import useFormattedDateTime from '@/mixins/useFormattedDateTime';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXDatepickerField',
  props: {
  value: {
    type: String as PropType<string>,
    default: ''
  },
  earliest: {
    type: [String, Date] as PropType<string | Date | null>,
    default: null
  },
  latest: {
    type: [String, Date] as PropType<string | Date | null>,
    default: null
  },
  isSecondary: Boolean,
},
  emits: ['input'],
  setup(__props, { emit }) {

const props = __props;





const { isSmartphoneWidth } = useResponsiveness();

const { getFormattedDate } = useFormattedDateTime();

const isOpen = ref(false);

const prettyDate = computed(() => getFormattedDate(props.value));

const onFocusField = () => {
  isOpen.value = true;
};

const onSelectTimelevel = (timeLevel: BcxDatePickerTimeLevel) => {
  if (timeLevel === BcxDatePickerTimeLevel.MONTH) isOpen.value = false;
};

// value field will always be kept as a string, no matte what format was given initially:
const vmValueDate = computed({
  get: () => props.value || new Date(),
  set: (value: Date | null | string) => {
    if (!value) {
      emit('input', '');
    } else if (typeof value === 'string') {
      emit('input', value);
    } else {
      emit('input', value.toISOString().slice(0, 10));
    }
  }
});


return { __sfc: true,props, emit, isSmartphoneWidth, getFormattedDate, isOpen, prettyDate, onFocusField, onSelectTimelevel, vmValueDate, BCXQuickLayer, BCXDatePicker, X }
}

})